const TC_REF_WAVELENGTH = 550;
const TC_CYCLE_PX = 65;
const TC_WAVE_HEIGHT = 40;
const TC_WAVE_SPEED = 0.06;

const waveAnimations = new Map();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tool-capabilities]').forEach(section => {
    initToolCapabilities(section);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('[data-wave]').forEach(waveEl => {
        waveEl.removeAttribute('data-rendered');
        renderWave(waveEl);
      });
    }, 150);
  });
});


const initToolCapabilities = (section) => {
  const tabs = [...section.querySelectorAll('[data-tab-index]')];
  const panel = section.querySelector('[data-panel-index]');

  if (!panel) return;

  const subtabs = [...panel.querySelectorAll('[data-subtab-index]')];
  const subpanels = [...panel.querySelectorAll('[data-subpanel-index]')];
  const panelCard = panel.querySelector('.pdp-tool-capabilities__panel-card');

  const scrollIntoView = (el) => {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  const activateSubtab = (subtab) => {
    const subtabIndex = parseInt(subtab.dataset.subtabIndex, 10);
    const modeIndex = parseInt(subtab.dataset.modeIndex, 10);

    subtabs.forEach(st => {
      st.classList.remove('is-active');
      st.setAttribute('aria-selected', 'false');
      if (parseInt(st.dataset.modeIndex, 10) === modeIndex) {
        st.classList.add('is-mode-active');
      } else {
        st.classList.remove('is-mode-active');
      }
    });
    subtab.classList.add('is-active');
    subtab.setAttribute('aria-selected', 'true');
    scrollIntoView(subtab);

    tabs.forEach(t => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    const matchingTab = tabs.find(t => parseInt(t.dataset.tabIndex, 10) === modeIndex);
    if (matchingTab) {
      matchingTab.classList.add('is-active');
      matchingTab.setAttribute('aria-selected', 'true');
      scrollIntoView(matchingTab);
    }

    subpanels.forEach(sp => sp.classList.remove('is-active'));
    const activeSubpanel = subpanels.find(
      sp => parseInt(sp.dataset.subpanelIndex, 10) === subtabIndex
    );
    if (!activeSubpanel) return;
    activeSubpanel.classList.add('is-active');
    renderSubpanelDiagram(activeSubpanel);
  };

  subtabs.forEach(subtab => {
    subtab.addEventListener('click', () => activateSubtab(subtab));
  });

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabIndex = parseInt(tab.dataset.tabIndex, 10);
      tabs.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      scrollIntoView(tab);

      const firstModeSubtab = subtabs.find(
        st => parseInt(st.dataset.modeIndex, 10) === tabIndex
      );
      if (firstModeSubtab) {
        if (panelCard) panelCard.style.display = '';
        activateSubtab(firstModeSubtab);
      } else {
        subtabs.forEach(st => {
          st.classList.remove('is-active', 'is-mode-active');
          st.setAttribute('aria-selected', 'false');
        });
        subpanels.forEach(sp => sp.classList.remove('is-active'));
        if (panelCard) panelCard.style.display = 'none';
      }
    });
  });

  const firstActiveSubpanel = panel.querySelector('.pdp-tool-capabilities__subpanel.is-active');
  if (firstActiveSubpanel) renderSubpanelDiagram(firstActiveSubpanel);

  const initActiveSubtab = subtabs.find(st => st.classList.contains('is-active'));
  if (initActiveSubtab) {
    const initModeIndex = parseInt(initActiveSubtab.dataset.modeIndex, 10);
    subtabs.forEach(st => {
      if (parseInt(st.dataset.modeIndex, 10) === initModeIndex) {
        st.classList.add('is-mode-active');
      }
    });
  }
};


// start of code written by SJ to replace the DevX code block above

/*
const initToolCapabilities = (section) => {
  const tabs = [...section.querySelectorAll('[data-tab-index]')];
  const panel = section.querySelector('[data-panel-index]');

  if (!panel) return;

  const subtabs = [...panel.querySelectorAll('[data-subtab-index]')];
  const subpanels = [...panel.querySelectorAll('[data-subpanel-index]')];
  const panelCard = panel.querySelector('.pdp-tool-capabilities__panel-card');

  const scrollIntoView = (el) => {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  const activateSubtab = (subtab) => {
    const subtabIndex = parseInt(subtab.dataset.subtabIndex, 10);
    const modeIndex = parseInt(subtab.dataset.modeIndex, 10);

    // 1. FILTER SUBTABS: Hide any subtabs that don't belong to the active mode
    subtabs.forEach(st => {
      st.classList.remove('is-active');
      st.setAttribute('aria-selected', 'false');
      if (parseInt(st.dataset.modeIndex, 10) === modeIndex) {
        st.classList.add('is-mode-active');
        st.style.display = ''; // Force show
      } else {
        st.classList.remove('is-mode-active');
        st.style.display = 'none'; // Force hide duplicates from other modes
      }
    });

    subtab.classList.add('is-active');
    subtab.setAttribute('aria-selected', 'true');
    scrollIntoView(subtab);

    // 2. SYNC TOP TABS
    tabs.forEach(t => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    const matchingTab = tabs.find(t => parseInt(t.dataset.tabIndex, 10) === modeIndex);
    if (matchingTab) {
      matchingTab.classList.add('is-active');
      matchingTab.setAttribute('aria-selected', 'true');
      scrollIntoView(matchingTab);
    }

    // 3. FILTER SUBPANELS: Hide all, then only show the one matching the mode AND subtab index
    subpanels.forEach(sp => {
      sp.classList.remove('is-active');
      sp.style.display = 'none'; // Force hide to prevent overlaps
    });

    const activeSubpanel = subpanels.find(
      sp => parseInt(sp.dataset.subpanelIndex, 10) === subtabIndex &&
            parseInt(sp.dataset.modeIndex, 10) === modeIndex
    );

    if (!activeSubpanel) return;
    activeSubpanel.style.display = ''; // Force show correct panel
    activeSubpanel.classList.add('is-active');
    renderSubpanelDiagram(activeSubpanel);
  };

  // Add click listeners to subtabs
  subtabs.forEach(subtab => {
    subtab.addEventListener('click', () => activateSubtab(subtab));
  });

  // Add click listeners to main mode tabs
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabIndex = parseInt(tab.dataset.tabIndex, 10);
      
      tabs.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      scrollIntoView(tab);

      // Find the first subtab in this specific mode and activate it
      const firstModeSubtab = subtabs.find(
        st => parseInt(st.dataset.modeIndex, 10) === tabIndex
      );

      if (firstModeSubtab) {
        if (panelCard) panelCard.style.display = '';
        activateSubtab(firstModeSubtab);
      } else {
        // Failsafe if mode has no subtabs
        subtabs.forEach(st => {
          st.classList.remove('is-active', 'is-mode-active');
          st.setAttribute('aria-selected', 'false');
          st.style.display = 'none';
        });
        subpanels.forEach(sp => {
          sp.classList.remove('is-active');
          sp.style.display = 'none';
        });
        if (panelCard) panelCard.style.display = 'none';
      }
    });
  });

  // INITIALIZE ON LOAD
  const initActiveSubtab = subtabs.find(st => st.classList.contains('is-active'));
  if (initActiveSubtab) {
    activateSubtab(initActiveSubtab);
  } else if (tabs.length > 0) {
    tabs[0].click(); // Auto-click first tab to ensure clean initial state
  }
};

*/
// end of code written by SJ to replace the DevX code block above



const renderSubpanelDiagram = (subpanel) => {
  const waveEl = subpanel.querySelector('[data-wave]');
  const tempBarEl = subpanel.querySelector('[data-temp-bar]');

  if (waveEl) renderWave(waveEl);
  if (tempBarEl && !tempBarEl.dataset.rendered) {
    renderTempBar(tempBarEl);
    tempBarEl.dataset.rendered = '1';
  }
};

const renderWave = (container) => {
  if (waveAnimations.has(container)) {
    cancelAnimationFrame(waveAnimations.get(container));
    waveAnimations.delete(container);
  }

  const wavelength = parseInt(container.dataset.wavelength, 10) || TC_REF_WAVELENGTH;
  const color = container.dataset.color || '#888888';
  const width = container.offsetWidth;

  if (!width) return;

  const svg = container.querySelector('.pdp-tool-capabilities__wave-svg');
  const path = container.querySelector('.pdp-tool-capabilities__wave-path');
  if (!svg || !path) return;

  svg.setAttribute('width', width);
  svg.setAttribute('height', TC_WAVE_HEIGHT);
  svg.setAttribute('viewBox', `0 0 ${width} ${TC_WAVE_HEIGHT}`);
  path.setAttribute('stroke', color);

  const cycleLength = TC_CYCLE_PX * (wavelength / TC_REF_WAVELENGTH);
  const amplitude = 8;
  const centerY = TC_WAVE_HEIGHT / 2;

  const points = [];
  for (let x = 0; x <= width; x += 2) {
    points.push({ x, y: centerY + amplitude * Math.sin((2 * Math.PI * x) / cycleLength) });
  }

  let progress = 0;
  let opacity = 1;
  let animPhase = 'drawing';
  const DRAW_SPEED = 4;
  const FADE_SPEED = 0.025;

  const draw = () => {
    if (animPhase === 'drawing') {
      progress = Math.min(progress + DRAW_SPEED, points.length - 1);

      let d = '';
      for (let i = 0; i <= progress; i++) {
        const { x, y } = points[i];
        d += i === 0
          ? `M ${x.toFixed(1)} ${y.toFixed(1)}`
          : ` L ${x.toFixed(1)} ${y.toFixed(1)}`;
      }
      path.setAttribute('d', d);
      path.style.opacity = '1';

      if (progress >= points.length - 1) {
        animPhase = 'fading';
        opacity = 1;
      }
    } else {
      opacity -= FADE_SPEED;
      path.style.opacity = Math.max(0, opacity).toString();

      if (opacity <= 0) {
        animPhase = 'drawing';
        progress = 0;
        path.setAttribute('d', '');
        path.style.opacity = '1';
      }
    }

    waveAnimations.set(container, requestAnimationFrame(draw));
  };

  waveAnimations.set(container, requestAnimationFrame(draw));
  container.dataset.rendered = '1';
};

const renderTempBar = (container) => {
  const start = parseFloat(container.dataset.start) || 0;
  const end = parseFloat(container.dataset.end) || 100;
  const colorStart = container.dataset.colorStart || '#f6ad55';
  const colorEnd = container.dataset.colorEnd || '#fc8181';

  const pct = end > 0 ? Math.max(0, Math.min(100, (start / end) * 100)) : 0;

  container.style.setProperty('--tc-color-start', colorStart);
  container.style.setProperty('--tc-color-end', colorEnd);
  container.style.setProperty('--tc-fill-pct', `${pct}%`);
};

